/*
  SunBorn 9/30 — Minicart colorway swatches + instant swaps.

  1. SPLIT-COLORWAY SWATCHES: split SKUs (one product per colorway, tagged
     "Group: <slug>", siblings in hidden smart collection /collections/group-<slug>)
     only have ONE color value each, so the drawer swapper
     (assets/sunborn-cart-drawer.js, sbSwap) showed a single swatch. This add-on
     replaces that row with one swatch per sibling. Tapping a sibling swaps the
     line to the SAME SIZE in that colorway with one atomic /cart/update.js call
     (no /cart/add.js, so no fake Add To Cart pixel event), then refreshes the
     drawer.

  2. SPEED (all products, combined + split):
     - Sibling /products/<h>.js data is prefetched into memory and window.fetch
       serves it to the core swapper, so a split swap doesn't wait on a fresh
       product download (Shopify sends no-store on that endpoint).
     - The swap's /cart/update.js response is kept as the current cart; the
       swatch row is replaced synchronously in the MutationObserver (before
       paint) — no extra /cart.js round trip, no single-swatch flash.
     - Instant feedback on EVERY product: the tapped color/size pill goes
       active and the line image/title change the moment it's tapped; the
       network catches up behind it.

  3. PAGE-LOAD COST: nothing is fetched on page load. Data is only loaded when
     the shopper shows cart intent — hovering/touching/focusing the cart icon,
     or the drawer opening (which includes every Add To Cart). Empty carts
     never fetch anything.

  Loaded sitewide (defer) from snippets/back-to-top.liquid.
*/
(function () {
  if (window.__sbCartSiblings) return;
  window.__sbCartSiblings = true;

  var HEX = {
    'Oji Black': '#111111', 'Eze Pink': '#FEA6A9', 'Adaeze Pink': '#FEA6A9',
    'Ocha White': '#F5F1E8', 'Igwe Blue': '#A3BED2', 'Ugo Purple': '#522760',
    'Royal Purple': '#522760', 'Sango Orange': '#C45500', 'Uhie Red': '#C1272D',
    'Ntụ Gray': '#B2AFAA', 'Anụnụ Blue': '#171F2C', 'Aja Sand': '#E7DED0',
    'Ubi Green': '#6A561C', 'Natural': '#DFCEA6'
  };
  var COLOR_NAMES = ['color', 'colour', 'couleur', 'cor', 'colore', 'farbe'];

  var handleToColl = {};   /* handle -> group collection handle, '' if none */
  var groupData = {};      /* coll -> products[] (products.json) */
  var groupPending = {};
  var jsCache = {};        /* handle -> /products/<h>.js JSON */
  var jsPending = {};
  var lastCart = null;
  var busy = {};
  var warmed = false;

  /* ---- serve cached product JSON to the core swapper ---- */
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var m = /^(?:https?:\/\/[^\/]+)?\/products\/([^\/?#]+)\.js(?:$|\?)/.exec(url);
      if (m && (!init || !init.method || init.method === 'GET') && jsCache[m[1]]) {
        return Promise.resolve(new Response(JSON.stringify(jsCache[m[1]]), {
          status: 200, headers: { 'Content-Type': 'application/json' }
        }));
      }
    } catch (e) {}
    return origFetch(input, init);
  };

  function hex(name) {
    var clean = (name || '').replace(/[\u2122\u00AE]/g, '').trim();
    return HEX[clean] || '#999999';
  }

  function getJSON(url) {
    return origFetch(url).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function groupSlug(tags) {
    if (typeof tags === 'string') tags = tags.split(/,\s*/);
    for (var i = 0; i < (tags || []).length; i++) {
      var m = /^\s*Group:\s*(.+?)\s*$/i.exec(tags[i]);
      if (m) return m[1];
    }
    return null;
  }

  function optIndex(product, names) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var n = (typeof opts[i] === 'string' ? opts[i] : opts[i].name || '').toLowerCase();
      if (names.indexOf(n) > -1) return i;
    }
    return -1;
  }

  function sizeOf(item) {
    var ow = item.options_with_values || [];
    for (var i = 0; i < ow.length; i++) {
      if (COLOR_NAMES.indexOf(String(ow[i].name).toLowerCase()) === -1) return ow[i].value;
    }
    return null;
  }

  function imgUrl(src, w) {
    if (!src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300);
  }

  function prefetchSiblings(coll) {
    (groupData[coll] || []).forEach(function (sib) {
      handleToColl[sib.handle] = coll;
      if (jsCache[sib.handle] || jsPending[sib.handle]) return;
      jsPending[sib.handle] = getJSON('/products/' + sib.handle + '.js').then(function (p) {
        jsCache[sib.handle] = p;
      }).catch(function () {}).finally(function () { delete jsPending[sib.handle]; });
    });
  }

  function loadProduct(handle) {
    if (jsCache[handle]) return Promise.resolve(jsCache[handle]);
    if (!jsPending[handle]) {
      jsPending[handle] = getJSON('/products/' + handle + '.js').then(function (p) {
        jsCache[handle] = p;
        return p;
      }).finally(function () { delete jsPending[handle]; });
    }
    return jsPending[handle];
  }

  function loadGroupFor(handle) {
    return loadProduct(handle).then(function (product) {
      if (handleToColl[handle] === undefined) {
        var slug = groupSlug(product.tags);
        handleToColl[handle] = slug ? (slug.indexOf('group-') === 0 ? slug : 'group-' + slug) : '';
      }
      var coll = handleToColl[handle];
      if (!coll || groupData[coll]) return coll;
      if (!groupPending[coll]) {
        groupPending[coll] = getJSON('/collections/' + coll + '/products.json?limit=50').then(function (d) {
          groupData[coll] = (d && d.products) || [];
          prefetchSiblings(coll);
          return coll;
        }).finally(function () { delete groupPending[coll]; });
      }
      return groupPending[coll];
    });
  }

  function itemForEl(el, idx) {
    if (!lastCart || !lastCart.items) return null;
    var inp = el.querySelector('[data-quantity-variant-id]');
    var vid = inp && inp.getAttribute('data-quantity-variant-id');
    if (vid) {
      for (var i = 0; i < lastCart.items.length; i++) {
        if (String(lastCart.items[i].variant_id) === String(vid)) return lastCart.items[i];
      }
      return null;
    }
    return lastCart.items[idx] || null;
  }

  function setLineVisual(el, src, title) {
    var img = el.querySelector('.card-img img');
    if (img && src) {
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
    }
    var t = el.querySelector('.card-title');
    if (t && title) t.textContent = title;
    el.classList.add('sb-sib-swapping');
  }

  /* ---- split-colorway swap ---- */
  function swap(el, item, sib, variantId, wrap, pill) {
    if (busy[item.key]) return;
    busy[item.key] = true;
    wrap.querySelectorAll('.sb-sib-color-row .sb-swap-pill').forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');
    setLineVisual(el, imgUrl(sib.images && sib.images[0] && sib.images[0].src), sib.title);

    var updates = {};
    updates[item.key] = 0;
    var existing = lastCart && (lastCart.items || []).find(function (i) {
      return String(i.variant_id) === String(variantId) && i.key !== item.key;
    });
    updates[String(variantId)] = (existing ? existing.quantity : 0) + item.quantity;

    origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('sibling swap failed');
      return res.json();
    }).then(function (cart) {
      lastCart = cart;
      if (typeof window.sbRefreshDrawer === 'function') return window.sbRefreshDrawer();
    }).catch(function (err) {
      console.error('SunBorn cart sibling swap failed:', err);
      el.classList.remove('sb-sib-swapping');
      scheduleAsync();
    }).finally(function () { busy[item.key] = false; });
  }

  function buildRow(el, wrap, item, siblings) {
    var size = sizeOf(item);
    var row = document.createElement('div');
    row.className = 'sb-swap-row sb-swap-row-color sb-sib-color-row';
    siblings.forEach(function (sib) {
      var ci = optIndex(sib, COLOR_NAMES);
      var colorKey = ci > -1 ? 'option' + (ci + 1) : null;
      var color = colorKey && sib.variants[0] ? sib.variants[0][colorKey] : sib.title;
      var target = null;
      (sib.variants || []).forEach(function (v) {
        if (target) return;
        if (size == null || [v.option1, v.option2, v.option3].indexOf(size) > -1) target = v;
      });
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'sb-swap-pill sb-swap-swatch';
      pill.style.setProperty('--sb-swatch-color', hex(color));
      pill.style.setProperty('--sb-swatch-color-2', hex(color));
      pill.setAttribute('aria-label', color);
      pill.title = color;
      if (sib.handle === item.handle) pill.classList.add('is-active');
      if (!target || !target.available) pill.classList.add('is-sold-out');
      pill.addEventListener('click', function () {
        if (pill.classList.contains('is-active') || !target || !target.available) return;
        swap(el, item, sib, target.id, wrap, pill);
      });
      row.appendChild(pill);
    });
    return row;
  }

  /* ---- instant feedback for the CORE swapper's pills (combined SKUs, and
         size pills on split SKUs). Runs in capture phase, then applies the
         visual change on the next tick — AFTER the core click handler has
         already checked is-active and started its own swap. ---- */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('#ajaxcart .sb-swap-pill');
    if (!pill || pill.closest('.sb-sib-color-row')) return;
    if (pill.classList.contains('is-active') || pill.classList.contains('is-sold-out') || pill.classList.contains('is-loading')) return;
    var el = pill.closest('.cart-item');
    var row = pill.closest('.sb-swap-row');
    if (!el || !row) return;
    var isColor = row.classList.contains('sb-swap-row-color');
    setTimeout(function () {
      row.querySelectorAll('.sb-swap-pill').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      if (!isColor) return;
      var items = Array.prototype.slice.call(document.querySelectorAll('#ajaxcart-cartitems .cart-item'));
      var item = itemForEl(el, items.indexOf(el));
      var product = item && jsCache[item.handle];
      if (!product) return;
      var ci = optIndex(product, COLOR_NAMES);
      if (ci < 0) return;
      var size = sizeOf(item);
      var color = pill.title || pill.getAttribute('aria-label');
      var v = (product.variants || []).find(function (x) {
        var vals = [x.option1, x.option2, x.option3];
        return x['option' + (ci + 1)] === color && (size == null || vals.indexOf(size) > -1);
      });
      var src = v && v.featured_image && v.featured_image.src;
      if (src) setLineVisual(el, imgUrl(src), null);
    }, 0);
  }, true);

  /* returns true if everything that could be handled synchronously was */
  function processSync() {
    var domItems = document.querySelectorAll('#ajaxcart-cartitems .cart-item');
    var needAsync = false;
    Array.prototype.forEach.call(domItems, function (el, i) {
      var wrap = el.querySelector('.sb-swap');
      if (!wrap) return;
      el.classList.remove('sb-sib-swapping');
      var ours = wrap.querySelector('.sb-sib-color-row');
      var theirs = wrap.querySelector('.sb-swap-row-color:not(.sb-sib-color-row)');
      if (ours && !theirs) return;
      var item = itemForEl(el, i);
      if (!item) { needAsync = true; return; }
      var coll = handleToColl[item.handle];
      if (coll === '') return;
      if (coll === undefined || !groupData[coll]) { needAsync = true; return; }
      var sibs = groupData[coll];
      if (sibs.length < 2) return;
      wrap.querySelectorAll('.sb-swap-row-color').forEach(function (r) { r.remove(); });
      wrap.appendChild(buildRow(el, wrap, item, sibs));
    });
    return !needAsync;
  }

  var asyncTimer = null;
  function scheduleAsync() {
    clearTimeout(asyncTimer);
    asyncTimer = setTimeout(function () {
      getJSON('/cart.js').then(function (cart) {
        lastCart = cart;
        return Promise.all((cart.items || []).map(function (it) {
          return loadGroupFor(it.handle).catch(function () {});
        }));
      }).then(function () { processSync(); }).catch(function () {});
    }, 40);
  }

  function cartIsEmpty() {
    var shell = document.querySelector('ajax-cart');
    return !shell || shell.classList.contains('is-empty');
  }

  function warm() {
    if (warmed || cartIsEmpty()) return;
    warmed = true;
    if (!processSync()) scheduleAsync();
  }

  function onMutations(muts) {
    if (!warmed) return;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.closest && (t.closest('.sb-sib-color-row') || t.closest('.sb-ctk'))) continue;
      if (!processSync()) scheduleAsync();
      return;
    }
  }

  function init() {
    var root = document.getElementById('ajaxcart');
    var shell = document.querySelector('ajax-cart');
    if (!root || !('MutationObserver' in window)) return;
    var st = document.createElement('style');
    st.textContent = '.cart-item.sb-sib-swapping .card-img img{opacity:.7;transition:opacity .15s}';
    document.head.appendChild(st);

    new MutationObserver(onMutations).observe(root, { childList: true, subtree: true });

    /* drawer opened (click on icon, Add To Cart, etc.) */
    if (shell) {
      new MutationObserver(function () {
        if (shell.classList.contains('active')) warm();
      }).observe(shell, { attributes: true, attributeFilter: ['class'] });
      if (shell.classList.contains('active')) warm();
    }

    /* cart intent: hover / touch / focus on the cart icon */
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('#ajax-cart-icon, .ajax-cart-icon, a[href="/cart"]')) warm();
      }, { passive: true, capture: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
